var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigationAndActionFaq(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 11.251c0-.058-.012-.108-.014-.165-.069 1.782-.858 3.193-2.485 4.414l-.589.448c-.725.561-1.023.907-1.185 1.393v.394c0 1.352-.98 2.453-2.185 2.453h-1.044l.023-2.591c.029-1.653.384-2.109 2.02-3.479l.714-.518c1.154-.833 1.477-1.585 1.529-2.423-.054-1.089-.681-1.564-2.084-1.564-.56 0-1.199.126-1.86.267a1.997 1.997 0 0 1-1.403-.187 2.252 2.252 0 0 1-1.343-1.544L11 7.788l2.799-.666c.672-.143 1.46-.223 2.199-.223 3.158 0 4.916 1.491 4.988 4.187.004-.085.014-.167.014-.254v.419zM15.063 26c-.981 0-1.78-.804-1.78-1.791 0-.988.799-1.791 1.78-1.791.983 0 1.783.803 1.783 1.791 0 .987-.8 1.791-1.783 1.791zM16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0z",
    fill: "#262626",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationAndActionFaq);
export default __webpack_public_path__ + "static/media/navigation-and-action-faq.161f7c80.svg";
export { ForwardRef as ReactComponent };